import { type FC } from "react";

export type LegendChipItem = {
  key: string;
  label: string;
  color: string;
};

interface ChartLegendChipsProps {
  items: ReadonlyArray<LegendChipItem>;
  activeKeys: string[];
  onToggle: (_key: string) => void;
  ariaLabel: string;
}

const ChartLegendChips: FC<ChartLegendChipsProps> = ({
  items,
  activeKeys,
  onToggle,
  ariaLabel,
}) => (
  <fieldset className="engagement-overview-legend-chips" aria-label={ariaLabel}>
    <legend className="engagement-overview-visually-hidden">{ariaLabel}</legend>
    {items.map(item => {
      const active = activeKeys.includes(item.key);
      return (
        <button
          key={item.key}
          type="button"
          className={
            active
              ? "engagement-overview-legend-chips__item engagement-overview-legend-chips__item--active"
              : "engagement-overview-legend-chips__item"
          }
          onClick={() => onToggle(item.key)}
        >
          <span
            className={`engagement-overview-legend-chips__dot engagement-overview-legend-chips__dot--${item.key}`}
            aria-hidden
          />
          {item.label}
        </button>
      );
    })}
  </fieldset>
);

export default ChartLegendChips;
